const currentModel = (state = {}, action) => {
    switch (action.type) {
        case 'SET_CURRENT_MODEL':
            return {
                ...state,
                currentModel: action.payload
            };
        case 'UPDATE_CURRENT_MODEL':
            return {
                ...state,
                currentModel: action.payload
            };
        case 'SET_CURRENT_MODEL_POS':
            return {
                ...state,
                pos: action.payload
            };
        default:
            return state;
    }
};

export default currentModel;
